if (document.readyState !== 'loading') {
  vzInit();
} else {
  document.addEventListener('DOMContentLoaded', vzInit);
}

function vzRunWhenIdle(callback, timeout = 1200) {
  if (typeof callback !== 'function') {
    return;
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, {timeout});
    return;
  }

  window.setTimeout(callback, timeout);
}

function vzInit() {
  // vz-lazyload
  if (typeof vzLazyLoadInit === 'function') {
    vzLazyLoadInit();
  } else if (typeof LazyLoad !== 'undefined') {
    window.vzLazyLoadInstance = new LazyLoad({});
  }

  // menu
  vzMenuNav();

  // sticky-nav
  stickyNavInit();
  if (typeof stickyNavBind === 'function') {
    stickyNavBind();
  }

  // vz-functions
  vzFocusSearch();
  vzSmoothScrollInit();

  // ajax-loadmore
  vzAjaxLoadMore();

  toggleCustomAccordions();
  toggleCatFilter();

  vzRunWhenIdle(function() {
    if (typeof vzFoundationInit === 'function') {
      vzFoundationInit();
    }

    // ajax-postview
    vzAjaxPostView();

    // vz-slider
    swiperInit();

    // vz-functions
    vzExternalLinksTarget();

    // vz-autoreveal
    initAutoReveal();

    // toc
    vzTocInit();

    // single-progressbar
    progressBarInit();

    // Form scroll open
    scrollFormOpen();

    // Collapse the intro above an open HubSpot form accordion
    formAccordionHideIntro();

    // rest-jobs-filter
    vzRestJobsFilter();

    if (typeof vzBackToTopInit === 'function') {
      vzBackToTopInit();
    }

    if (typeof vzDropcapInit === 'function') {
      vzDropcapInit();
    }

    if (typeof vzSearchInit === 'function') {
      vzSearchInit();
    }

    if (typeof vzScrollToCommentInit === 'function') {
      vzScrollToCommentInit();
    }

    if (typeof vzWpFoundationCompatInit === 'function') {
      vzWpFoundationCompatInit();
    }

    if (typeof vzCommentboxGrowInit === 'function') {
      vzCommentboxGrowInit();
    }

    if (typeof vzGlossaryOffcanvasInit === 'function') {
      vzGlossaryOffcanvasInit();
    }

    libraryInit();
    setAccordionHeight();
  });
}
